<template>
    <div class="AboutUs">
        <h1 class="AboutTitle">Have any questions?</h1>
        <h2> Email: info@intextelectric.ca Phone: <a href="tel:+15879695387" style="text-decoration:none;">(587) 969-5387</a></h2>
        <div class="contact">
            <div class="messageImg">
            </div>
            <div class="contactForm">
                <input type="name" class="contactInp" placeholder="   Full Name" v-model="FullName">
                <input type="email" class="contactInp" placeholder="   Email" v-model="Email">
                <input type="phone" class="contactInp" placeholder="   Phone" v-model="Phone">
                <input type="company" class="contactInp" placeholder="   Company" v-model="Company">
                <textarea class="bubble-element MultiLineInput" 
                data-gramm_editor="false" 
                placeholder="Your questions..." 
                maxlength="" 
                style=" height: 100px; border: 1px solid black; 
                background-color: rgb(255, 255, 255); border-radius: 16px; 
                font-size: 16px; color: rgb(0, 0, 0); 
                line-height: 1; padding: 12px 20px; transition: border-color 200ms ease 0s, box-shadow 200ms ease 0s;" 
                tabindex="4" v-model="Message">
                </textarea>
                <button class="sendBtn" @click="sendEmail">SEND MESSAGE</button>
                <h6>{{Result}}</h6>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
    export default {
        data() {
            return {
                FullName: "",
                Email: "",
                Phone: "",
                Company: "",
                Message: "",
                Result: "",
            }
        },
        methods: {
            sendEmail(){ 
                axios.post('/sendEmail',{
                    name: this.FullName,
                    company: this.Company,
                    email: this.Email,
                    phone: this.Phone,
                    message: this.Message
                    }).then(res => {
                        this.Result = res.data;
                    }).catch(error => {
                        if(error){
                            this.Result = "You can send 1 email every 5 minutes. Please wait a moment.";
                        }
                    })
            }
        },
    }
</script>

<style lang="scss" scoped>
.AboutUs{
    background: linear-gradient(rgb(255, 255, 255), rgba(255, 255, 255, 0.87)),url("../assets/aboutus.jpg");
    background-position: center 0px;
    background-size: cover;
    background-repeat: no-repeat;
    width: 100%;
    height: 900px;
    .AboutTitle{
        font-family: 'Old Standard TT', ;
        font-size: 50px;
        letter-spacing: 5px;
        text-align: center;
        padding-top: 75px;
        color: rgb(0, 0, 0);
    }
    h2{
        font-family: 'Old Standard TT', ;
        font-size: 20px;
        text-align: center;
        margin-top: 15px;
        color:rgba(0, 0, 0, 0.664);
        a{
        font-family: 'Old Standard TT', ;
        font-size: 20px;
        color:rgba(0, 0, 0, 0.664);
        }
    }
}
.contact{
    display: flex;
    width: 70%;
    margin-left: 15%;
    margin-top: 70px;
    .messageImg{
        background-image: url("../assets/letter.svg");
        height: 325px;
        width: 50%;
        background-position-x: center;
        align-self: center;
        background-repeat: no-repeat;
        flex: 1;
    }
    .contactForm{
        display: flex;
        flex:1;
        flex-direction: column;
        align-items: center;
        .contactInp{
            width: 425px;
            height: 40px;
            margin: 15px;
            border: 1px solid grey;
            border-radius: 18px;
        }
        .sendBtn{
            width: 400px;
            height: 50px;
            margin-top: 20px;
            border: 1px solid rgb(0, 0, 0);
            cursor: pointer;
            background: #fd6c0be1; 
            border-radius: 20px;
            color: white;
            font-size: 18px;
            font-weight: bold;
        }
        textarea{
            width: 400px;
        }
    }
}
@media only screen and (max-width: 1200px) {
    .AboutUs{
    .AboutTitle{
        width: 90%;
        margin-left: 5%;
        font-size: 40px;
    }
    h2{
        width: 90%;
        margin-left: 5%;
        font-size: 20px;
    }
    }
    .contact{
        flex-direction: column;
        .messageImg{
            display: none;
        }
    }
}
@media only screen and (max-width: 600px) {
    .contact{
        .contactForm{
            .contactInp{
                width: 300px;
            }
            textarea{
                width: 300px;
            }
        .sendBtn{
            width: 200px;
        }
        
}
        flex-direction: column;
        .messageImg{
            display: none;
        }
    }
}
@media only screen and (max-width: 500px) {
    .AboutUs{
    .AboutTitle{
        width: 80%;
        margin-left: 10%;
    }
    h2{
        width: 80%;
        margin-left: 10%;
    }
    }
}
</style>